import { DrawerId, FormId } from "components/CC/types/models.ts";
import { BaseConnectionCreatorDrawer } from "components/CC/UI/BaseConnectionCreatorDrawer.tsx";
import { usePaldockTranslation } from "hooks/usePaldockTranslation.tsx";

import { EndForm } from "../Forms/EndForm.tsx";

export const EndDrawer = () => {
    const { t } = usePaldockTranslation("components.connection-creator");

    return (
        <BaseConnectionCreatorDrawer drawerId={DrawerId.End} title={t("nodes.end.drawers.title")}>
            <EndForm formId={FormId.EndForm} />
        </BaseConnectionCreatorDrawer>
    );
};
